import partners from './partners';
import partner from './partner';
import menu from './menu';
import productOpen from './productOpen';
import restaurantsCategories from './restaurantsCategories';
import filters from './filters';
import partnersNew from './partnersNew';
import currency from './currency';

export default {partners, partner, menu, productOpen, restaurantsCategories, filters, partnersNew, currency}